import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../theme/palette';
import { CURRENT_CHALLENGE_SEASON } from 'helpers/challenge/getChallengeInfos';

const style = () =>
  createStyles({
    root: {
      fontWeight: 600,
      boxSizing: 'border-box',
      color: palette.text.secondary,
      transition: '0.3s ease',
      borderRadius: palette.borderRadius.default,
      '&:hover': {
        transform: 'scale(1.1)'
      }
    },
    borderDefault: {
      background:
        CURRENT_CHALLENGE_SEASON === 'autumn'
          ? palette.background.autumn
          : palette.background.spring
    },
    borderGold: {
      background:
        'linear-gradient(90deg, #FFC90A 0%, #FFFFFF 48%, #EAC339 100%)',
      backgroundSize: '400% 400%',
      animation: `$borderAnimation linear infinite alternate 9s`
    },
    borderSilver: {
      background:
        'linear-gradient(0deg, #7D7D7D 0%, #FBFBFB 75%, #8A8989 100%)',
      backgroundSize: '400% 400%',
      animation: `$borderAnimation linear infinite alternate 9s`
    },
    borderBronze: {
      background:
        'linear-gradient(180deg, #A65A00 0%, #FCD4A5 75%, #AE6611 100%)',
      backgroundSize: '400% 400%',
      animation: `$borderAnimation linear infinite alternate 9s`
    },
    borderHalloween: {
      background:
        'linear-gradient(180deg, rgba(232, 124, 48, 0.7) 0%, rgba(232, 87, 48, 0.7) 50%, rgba(232, 124, 48, 0.7) 100%)',
      backgroundSize: '400% 400%',
      animation: `$borderAnimation linear infinite alternate 9s`
    },
    '@keyframes borderAnimation': {
      '0%': {
        backgroundPosition: '0% 0%'
      },
      '100%': {
        backgroundPosition: '400% 400%'
      }
    },
    noAvatar: {
      backgroundColor: palette.title.primary,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-around'
    },
    avatar: {
      padding: '4px',
      borderRadius: palette.borderRadius.default,
      width: '100%',
      height: '100%'
    },
    extrasmall: {
      width: '48px',
      height: '48px'
    },
    small: {
      width: '57px',
      height: '57px'
    },
    leaderboard: {
      width: '74px',
      height: '74px'
    },
    large: {
      width: '84px',
      height: '84px'
    },
    sidebar: {
      width: '118px',
      height: '118px',
      '@media (max-width:1440px)': {
        width: '74px',
        height: '74px',
        '&:hover': {
          transform: 'scale(1)'
        }
      }
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
